import { GET_INSURANCE_COMPANY_BY_SLUG_REQUEST } from 'redux/actions';

export const isCooperationCompanyLoading = (state) => state.insuranceCompany.openRequests.includes(GET_INSURANCE_COMPANY_BY_SLUG_REQUEST);
